import { render, staticRenderFns } from "./SingleMenuAccordion.vue?vue&type=template&id=70d3d160&"
import script from "./SingleMenuAccordion.vue?vue&type=script&lang=js&"
export * from "./SingleMenuAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports